var GSS;
(function (GSS) {
    var SignalR;
    (function (SignalR) {
        var Notifications;
        (function (Notifications) {
            Notifications.getHub = function () {
                var hub = $.connection.notificationHub;
                hub.notificationCountEvent = new GSS.common.Event();
                hub.client.informAboutNewNotificationCount = function (count) { return hub.notificationCountEvent.notify(count); };
                var getNotificationCountPromise = hub.server.getNotificationCountPromise;
                hub.server.getNotificationCountPromise = function () {
                    return getNotificationCountPromise()
                        .done(function (count) { return hub.notificationCountEvent.notify(count); });
                };
                return function () {
                    return new Promise(function (resolve, reject) {
                        $.connection.hub.start()
                            .done(function () { return resolve(hub); })
                            .fail(function (_) { return reject(_); });
                    });
                };
            }();
        })(Notifications = SignalR.Notifications || (SignalR.Notifications = {}));
        var Users;
        (function (Users) {
            Users.getHub = function () {
                var hub = $.connection.usersHub;
                hub.UserManagementJobCompleteEvent = new GSS.common.Event();
                hub.client.informClientAboutJobComplete = function (isComplete) { return hub.UserManagementJobCompleteEvent.notify(isComplete); };
                return function () {
                    return new Promise(function (resolve, reject) {
                        $.connection.hub.start()
                            .done(function () { return resolve(hub); })
                            .fail(function (_) { return reject(_); });
                    });
                };
            }();
        })(Users = SignalR.Users || (SignalR.Users = {}));
        var Teams;
        (function (Teams) {
            Teams.getHub = function () {
                var hub = $.connection.teamsHub;
                hub.TeamsJobCompleteEvent = new GSS.common.Event();
                hub.client.informClientAboutJobComplete = function (isComplete) { return hub.TeamsJobCompleteEvent.notify(isComplete); };
                return function () {
                    return new Promise(function (resolve, reject) {
                        $.connection.hub.start()
                            .done(function () { return resolve(hub); })
                            .fail(function (_) { return reject(_); });
                    });
                };
            }();
        })(Teams = SignalR.Teams || (SignalR.Teams = {}));
        var ReportingGroup;
        (function (ReportingGroup) {
            ReportingGroup.getHub = function () {
                var hub = $.connection.reportingGroupHub;
                hub.ReportingGroupJobCompleteEvent = new GSS.common.Event();
                hub.client.informClientAboutJobComplete = function (isComplete) { return hub.ReportingGroupJobCompleteEvent.notify(isComplete); };
                return function () {
                    return new Promise(function (resolve, reject) {
                        $.connection.hub.start()
                            .done(function () { return resolve(hub); })
                            .fail(function (_) { return reject(_); });
                    });
                };
            }();
        })(ReportingGroup = SignalR.ReportingGroup || (SignalR.ReportingGroup = {}));
        var Project;
        (function (Project) {
            Project.getHub = function () {
                var hub = $.connection.projectHub;
                hub.ProjectJobCompleteEvent = new GSS.common.Event();
                hub.client.informClientProjectAboutJobComplete = function (jobEventData) { return hub.ProjectJobCompleteEvent.notify(jobEventData); };
                return function () {
                    return new Promise(function (resolve, reject) {
                        $.connection.hub.start()
                            .done(function () { return resolve(hub); })
                            .fail(function (_) { return reject(_); });
                    });
                };
            }();
        })(Project = SignalR.Project || (SignalR.Project = {}));
        var QuestionBank;
        (function (QuestionBank) {
            QuestionBank.getHub = function () {
                var hub = $.connection.questionBankHub;
                hub.OnJobStatusChanged = new GSS.common.Event();
                hub.client.OnJobStatusChanged = function (jobStatusChangedEventData) { return hub.OnJobStatusChanged.notify(jobStatusChangedEventData); };
                return function () {
                    return new Promise(function (resolve, reject) {
                        $.connection.hub.start()
                            .done(function () { return resolve(hub); })
                            .fail(function (_) { return reject(_); });
                    });
                };
            }();
        })(QuestionBank = SignalR.QuestionBank || (SignalR.QuestionBank = {}));
    })(SignalR = GSS.SignalR || (GSS.SignalR = {}));
})(GSS || (GSS = {}));
//# sourceMappingURL=GSS.signalr.js.map